import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import TabsPageLayout from 'src/components/TabsPageLayout';
import { PORTAL_ROUTE } from 'src/constants/routes';
import { WDAC_MANAGED_INSTALLERS_PREVIOUS_PATH, wdacManagedInstallersTabs } from '../constants';
import useGetManagedInstallersTabCounts from '../../../../../queries/managedInstallersDetails/useGetManagedInstallersTabCounts';
import useManagedInstallersGeneral from '../../../../../queries/managedInstallersDetails/useGetMangedInstallersGeneral';

const ManagedInstallersTabs = () => {
  const { managedInstallerId } = useParams();

  const { data: tabCountsData, isLoading: countsIsLoading } = useGetManagedInstallersTabCounts({
    managedInstallerId,
  });

  const { data } = useManagedInstallersGeneral({
    managedInstallerId,
  });

  const backNavigationPath = useMemo(() => {
    const storedPath = sessionStorage.getItem(WDAC_MANAGED_INSTALLERS_PREVIOUS_PATH);
    return storedPath || `${PORTAL_ROUTE}/wdac-results/managed-installers`;
  }, []);

  return (
    <div>
      <TabsPageLayout
        hasBackButton
        title={data?.binaryName || ''}
        tabs={wdacManagedInstallersTabs(
          managedInstallerId,
          tabCountsData?.totalAffectedCount,
          tabCountsData?.totalAlteredCount,
          countsIsLoading,
        )}
        backNavigationPath={backNavigationPath}
        wrapperProps={{
          sx: {
            maxWidth: '100%',
          },
        }}
        titleProps={{
          fontSize: '1.4rem',
        }}
      />
    </div>
  );
};

export default ManagedInstallersTabs;
